import React from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';

import ImageBase64 from '@Components/ImageBase64';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

import useStructureSrc from './useStructureSrc';

export default function StructureToBase64({ structure, customRenderer }) {
  const src = useStructureSrc(structure);

  if (!structure) {
    return null;
  }

  const renderImage = (imgSrc) => {
    if (isFunction(customRenderer)) {
      return customRenderer({ src: imgSrc });
    }
    // eslint-disable-next-line jsx-a11y/img-redundant-alt
    return <img className="structure-dialog--image" src={imgSrc} alt="chemical structure" />;
  };

  return (
    <ImageBase64 src={src}>
      {/* eslint-disable-next-line no-shadow */}
      {({ src }) => (src ? renderImage(src) : <SimpleSpinner />)}
    </ImageBase64>
  );
}

StructureToBase64.propTypes = {
  structure: PropTypes.string,
  customRenderer: PropTypes.func,
};
